import type { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';

const NUMERIC_COLUMNS = ['id', 'courier_id', 'shop_id', 'team_id', 'shipment_status_id'];

const MIGRATION_COLUMNS = new Set(['is_migrated', 'migration_id_mappings']);

function parseMigrationEqualsValue(value: unknown): boolean | null {
  if (value === true || value === false) return value;
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  const s = String(value).trim().toLowerCase();
  if (['true', '1', 'yes', 'si', 'sí', 'y'].includes(s)) return true;
  if (['false', '0', 'no', 'n'].includes(s)) return false;
  return null;
}

/**
 * Convierte una condición de filtro del UI al payload de advanced_filters de la API.
 * Incluye normalización de booleanos para columnas de migración (equals).
 */
export function mapFilterConditionToApiFilter(condition: FilterConditionOutput): {
  column: string;
  operator: string;
  value: string | string[] | number | number[] | boolean | null;
} {
  const { column, action, value } = condition;
  const apiColumn = column;
  const apiOperator = action;

  const isNumericColumn = NUMERIC_COLUMNS.includes(apiColumn);
  const isMigrationColumn = MIGRATION_COLUMNS.has(apiColumn);

  let processedValue: string | string[] | number | number[] | boolean | null = value;

  if (action === 'in' || action === 'not_in') {
    const arrayValue = Array.isArray(value) ? value : [value];
    processedValue = isNumericColumn ? arrayValue.map((v) => (typeof v === 'string' ? Number(v) : v)) : arrayValue;
  } else if (action === 'is_null' || action === 'is_not_null') {
    processedValue = null;
  } else if (action === 'between' && Array.isArray(value) && value.length === 2) {
    processedValue = value;
  } else if (isMigrationColumn && action === 'equals') {
    const singleValue = Array.isArray(value) ? value[0] : value;
    const parsed = parseMigrationEqualsValue(singleValue);
    processedValue = parsed !== null ? parsed : (singleValue as string | number | boolean | null);
  } else {
    const singleValue = Array.isArray(value) ? value[0] : value;
    if (isNumericColumn && typeof singleValue === 'string') {
      processedValue = Number(singleValue);
    } else {
      processedValue = singleValue as string | number | null;
    }
  }

  return {
    column: apiColumn,
    operator: apiOperator,
    value: processedValue,
  };
}
